// src/components/EmptyState.jsx
import React, { useState } from 'react';
import IdeaForm from './IdeaForm';

function EmptyState({ onCreateIdea }) {
  const [formData, setFormData] = useState({
    idea: '',
    description: '',
    tags: [],
    status: 'Drafted',
    rating: '1',
    subtasks: [],
    lessonsLearned: '',
    resources: []
  });

  const handleChange = (updatedData) => {
    setFormData(updatedData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onCreateIdea(formData);
    // Reset form after successful creation
    setFormData({
      idea: '',
      description: '',
      tags: [],
      status: 'Drafted',
      rating: '1',
      subtasks: [],
      lessonsLearned: ''
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-8">
      {/* Container */}
      <div className="w-full max-w-2xl bg-white dark:bg-slate-800 rounded-xl shadow-lg p-6 md:p-8">
        {/* Header */}
        <h2 className="text-xl font-bold mb-6 text-slate-400 dark:text-slate-300 text-center">
          Start your vault
        </h2>

        {/* Full Form */}
        <IdeaForm
          formData={formData}
          setFormData={handleChange}
          handleSubmit={handleSubmit}
          handleCancel={() => {}} // No-op since cancel is hidden
          hideCancel={true}
          autoFocus={true}
        />
      </div>
    </div>
  );
}

export default EmptyState;
